import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import { ROUTES } from 'routes/routes';

import PLUPlanner from './Planner/PLUPlanner';

import PLUItem from './PLUItem/PLUItem';

class PLUPage extends Component {
  render() {
    return (
      <Switch>
        <Route path={ROUTES.admin.plu} component={PLUPlanner} exact />
        <Route path={ROUTES.admin.pluItem} component={PLUItem} exact />
        <Route path={ROUTES.admin.pluItemNew} component={PLUItem} exact />
      </Switch>
    );
  }
}

export default PLUPage;
